import React from 'react';
import FaceRegistrationProvider from './useFaceRegistration';
import FaceRegistration from './FaceRegistration';

const FRregistration = params => {
  return (
    <FaceRegistrationProvider params={params}>
      <FaceRegistration />
    </FaceRegistrationProvider>
  );
};

export default FRregistration;
